import '@fabric-ds/icons/elements/bin-16';
import type { Result } from '@finn-no/search-frontend-clients/suggest';
import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultOption } from './ResultOption';
import type { ActionFunction, ResultsProps } from './ResultTypes';
import { SelectAction } from './ResultTypes';

const REMOVE_SEARCH_HISTORY_RESULT = {
    resultType: 'LASTSEARCHES',
} as Result;

export const lastSearchResultsAction: ActionFunction = ({
    config,
    metaData,
    result,
}) => {
    if (result === REMOVE_SEARCH_HISTORY_RESULT) {
        const { apiUrl, vertical } = config;
        const deleteLastSearchesUrl = `${apiUrl}/delete/lastsearches?vertical=${vertical}`;
        window.fetch(deleteLastSearchesUrl, {
            method: 'DELETE',
            credentials: 'include',
        });
        return SelectAction.KEEP_OPEN;
    } else {
        trackResultClick(result, metaData.tracking);
        window.location.href = result.url;
        return SelectAction.CLOSE;
    }
};

export function LastSearchResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    const removeSearchHistoryOption = (
        <div className="mt-10">
            <ResultOption result={REMOVE_SEARCH_HISTORY_RESULT}>
                {() => (
                    <button
                        className="button button--link button--small flex items-center space-x-8 text-gray-700 font-bold"
                        type="button"
                    >
                        {/* @ts-expect-error Property 'f-icon-bin16' does not exist on type 'JSX.IntrinsicElements'.ts(2339) */}
                        <f-icon-bin16 class="flex" />
                        <span>Fjern all søkehistorikk</span>
                    </button>
                )}
            </ResultOption>
        </div>
    );

    const hasLastSearches = resultGroup.results.length > 0;
    if (!hasLastSearches) {
        return null;
    }

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            <div className="grid md:grid-cols-2 gap-x-16 gap-y-6">
                {resultGroup.results.map((result) => (
                    <ResultOption
                        className="overflow-auto"
                        linkClass="flex space-x-4"
                        key={`${result.resultType}-${result.order}-${resultId}`}
                        result={result}
                    >
                        <span className="text-14 overflow-hidden overflow-ellipsis whitespace-nowrap">
                            {result.title}
                        </span>
                        <span className="text-14 text-gray-500 flex-shrink-0">
                            <span role="presentation">
                                {
                                    ' / ' /* intentional whitespace around slash */
                                }
                            </span>
                            {result.secondaryTitle}
                        </span>
                    </ResultOption>
                ))}
            </div>
            {removeSearchHistoryOption}
        </ResultGroup>
    );
}
